import { Plugin, registerPlugin } from '@capacitor/core';

interface IApplePayPlugin extends Plugin {
  canMakePayments(params: {
    networks: string[];
  }): Promise<{ available: boolean; hasCards: boolean }>;
  makePaymentRequest(params: {
    countryCode: string;
    currencyCode: string;
    total: number;
    merchantId: string;
    payeeName: string;
    itemLabel: string;
    cartLabels?: string[];
    cartPrices?: number[];
  }): Promise<void>;
  supportsCardNetwork(): Promise<void>;
}

export const ApplePayPlugin = registerPlugin<IApplePayPlugin>('ApplePayPlugin');
